<div class="pov-page">

  <!-- Title row -->
  <div class="pov-title-row">
    <h1 class="pov-title-row__name">{{ po.name }}</h1>
    <span class="pov-status pov-status--{{ po.status }}">{{ po.statusLabel }}</span>
    <div class="pov-title-row__actions">
      <button class="pov-icon-btn" title="Edit" aria-label="Edit purchase order">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
      </button>
      <button class="pov-icon-btn pov-icon-btn--danger" title="Delete" aria-label="Delete purchase order">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="3 6 5 6 21 6"/>
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
          <path d="M10 11v6M14 11v6"/>
          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Warning banner -->
  <div class="pov-banner pov-banner--warning" *ngIf="po.warningMessage" role="alert">
    <svg class="pov-banner__icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2L1 21h22L12 2zm0 3.5L20.5 19h-17L12 5.5zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z"/>
    </svg>
    <span>{{ po.warningMessage }}</span>
  </div>

  <!-- Main two-column layout -->
  <div class="pov-layout">

    <!-- Left: info cards -->
    <div class="pov-main">

      <!-- General information -->
      <section class="pov-card">
        <h2 class="pov-card__title">General information</h2>
        <div class="pov-grid">
          <div class="pov-field">
            <span class="pov-label">Purchase Order name</span>
            <span class="pov-value">{{ po.name }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Source type</span>
            <span class="pov-value">{{ po.sourceType }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Maker to execute</span>
            <span class="pov-value">{{ po.makerToExecute }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Company to bill</span>
            <span class="pov-value">{{ po.companyToBill }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">PO Type</span>
            <span class="pov-value">{{ po.poType }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Rappi owner</span>
            <span class="pov-value">{{ po.rappiOwner }}</span>
          </div>
        </div>
      </section>

      <!-- Purchase order document -->
      <section class="pov-card">
        <h2 class="pov-card__title">Purchase order document</h2>

        <div class="pov-doc" *ngIf="po.document">
          <div class="pov-doc__icon-wrap">
            <svg width="40" height="48" viewBox="0 0 40 48" fill="none">
              <rect width="40" height="48" rx="6" fill="#EEF4FF"/>
              <path d="M10 14h14l6 6v18a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2z"
                    stroke="#4589FF" stroke-width="2" fill="none"/>
              <path d="M24 14v8h6" stroke="#4589FF" stroke-width="2" fill="none"/>
              <line x1="14" y1="26" x2="26" y2="26" stroke="#4589FF" stroke-width="1.5" stroke-linecap="round"/>
              <line x1="14" y1="30" x2="26" y2="30" stroke="#4589FF" stroke-width="1.5" stroke-linecap="round"/>
              <line x1="14" y1="34" x2="22" y2="34" stroke="#4589FF" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="pov-doc__meta">
            <span class="pov-doc__name">{{ po.document.name }}</span>
            <span class="pov-doc__size">{{ po.document.size }}</span>
          </div>
          <button class="pov-doc__download" (click)="downloadDocument()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Download
          </button>
        </div>

        <div class="pov-doc--empty" *ngIf="!po.document">No document attached</div>
      </section>

      <!-- Budget & Dates -->
      <section class="pov-card">
        <h2 class="pov-card__title">Budget &amp; Dates</h2>
        <div class="pov-grid">
          <div class="pov-field">
            <span class="pov-label">PO Budget</span>
            <span class="pov-value pov-value--budget">
              ${{ formatCurrency(po.poBudget, po.poCurrency) }}
            </span>
          </div>
          <div class="pov-field">
            <span class="pov-label">PO Currency</span>
            <span class="pov-value">{{ po.poCurrency }}</span>
          </div>
          <div class="pov-field" *ngIf="po.coInvestmentPct !== undefined && po.coInvestmentPct !== null">
            <span class="pov-label">Co-Investment %</span>
            <span class="pov-value">{{ po.coInvestmentPct }}%</span>
          </div>
          <div class="pov-field" *ngIf="po.reInvestmentPct !== undefined && po.reInvestmentPct !== null">
            <span class="pov-label">Re-Investment %</span>
            <span class="pov-value">{{ po.reInvestmentPct }}%</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Effective date</span>
            <span class="pov-value">{{ formatDate(po.effectiveDate) }}</span>
          </div>
        </div>
      </section>

      <!-- Company to bill — contact details -->
      <section class="pov-card">
        <h2 class="pov-card__title">Company to bill</h2>
        <div class="pov-grid">
          <div class="pov-field">
            <span class="pov-label">Point of contact</span>
            <span class="pov-value">{{ po.pointOfContact }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Email</span>
            <span class="pov-value">{{ po.contactEmail }}</span>
          </div>
          <div class="pov-field" *ngIf="po.agency">
            <span class="pov-label">Agency</span>
            <span class="pov-value">{{ po.agency }}</span>
          </div>
        </div>
      </section>

    </div>

    <!-- Right: approval + comments -->
    <aside class="pov-sidebar">

      <!-- Approval -->
      <section class="pov-card">
        <h2 class="pov-card__title">Approval</h2>
        <button class="pov-btn pov-btn--primary" (click)="resubmitForApproval()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="1 4 1 10 7 10"/>
            <path d="M3.51 15a9 9 0 1 0 .49-3.51"/>
          </svg>
          Re submit for approval
        </button>
      </section>

      <!-- Comments -->
      <section class="pov-card pov-card--comments">
        <div class="pov-card__title-row">
          <h2 class="pov-card__title">Comments</h2>
          <div class="pov-card__title-actions">
            <button class="pov-icon-btn pov-icon-btn--sm" title="Attach file" aria-label="Attach file">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.41 17.41a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
              </svg>
            </button>
            <button class="pov-icon-btn pov-icon-btn--sm" title="Expand" aria-label="Expand comments">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 3 21 3 21 9"/>
                <polyline points="9 21 3 21 3 15"/>
                <line x1="21" y1="3" x2="14" y2="10"/>
                <line x1="3" y1="21" x2="10" y2="14"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- New comment input -->
        <div class="pov-comment-input">
          <input
            type="text"
            class="pov-comment-input__field"
            placeholder="Add comment"
            [(ngModel)]="newComment"
            (keydown.enter)="addComment()"
            aria-label="Add a comment"
          />
        </div>

        <!-- Comment list -->
        <div class="pov-comments" *ngIf="po.comments.length > 0">
          <div class="pov-comment" *ngFor="let comment of po.comments">
            <div
              class="pov-comment__avatar"
              [style.background]="getInitialsColor(comment.authorInitials)"
            >
              {{ comment.authorInitials }}
            </div>
            <div class="pov-comment__bubble">
              <div class="pov-comment__header">
                <span class="pov-comment__author">{{ comment.authorName }}</span>
                <span class="pov-comment__date">{{ comment.date }}</span>
              </div>
              <p class="pov-comment__text">{{ comment.text }}</p>
            </div>
          </div>
        </div>

        <p class="pov-comments--empty" *ngIf="po.comments.length === 0">No comments yet</p>
      </section>

    </aside>
  </div>
</div>
